export enum AuthenticationStatus {
  PENDING,
  AUTHENTICATED,
  UNAUTHENTICATED,
}
